import React from "react";
import styles from "./contact.module.scss";

const Contact: React.FC = () => {
  return (
    <div className={styles.contactContainer}>
      <div className={styles.contactGrid}>
        <div className={styles.contactItem}>
          <div className={styles.icon}>📧</div>
          <div className={styles.info}>
            <p className={styles.label}>Email</p>
            <a href="mailto:max@mgraetz.de" className={styles.value}>
              max@mgraetz.de
            </a>
          </div>
        </div>

        <div className={styles.contactItem}>
          <div className={styles.icon}>📱</div>
          <div className={styles.info}>
            <p className={styles.label}>Phone</p>
            <a href="tel:+4901785598780" className={styles.value}>
              01785598780
            </a>
          </div>
        </div>

        <div className={styles.contactItem}>
          <div className={styles.icon}>📍</div>
          <div className={styles.info}>
            <p className={styles.label}>Address</p>
            <p className={styles.value}>
              Stadtplatz 30
              <br />
              84453 Mühldorf a. Inn
              <br />
              Germany
            </p>
          </div>
        </div>

        <div className={styles.contactItem}>
          <div className={styles.icon}>🎂</div>
          <div className={styles.info}>
            <p className={styles.label}>Date of Birth</p>
            <p className={styles.value}>
              02.02.1993
              <br />
              Starnberg, Bavaria
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
